import { createContext, useState, useContext, useEffect } from "react";
import axios from 'axios';
import LocalStorage from "./LocalStorage";
import LoginData from "../repository/LoginData";
import {
  staticsGet as statics_staticsGet,
  staticsSet as statics_staticsSet,
  staticsReset as statics_staticsReset
} from './Statics'

export const MainContext = createContext();

export const MainProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");
  const [loginData, setLoginData] = useState();
  const [currencyData, setCurrencyData] = useState([]);
  const [searchParams, setSearchParams] = useState({});

  async function retrieveCurrencyData(token, language) {
    return () => axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/data`,
        {
          headers: {
            'x-token': token,
            "x-collection": "CURRENCIES",
            "x-limit": 0,
            "x-filter": "",
            "x-sort": "Shortname",
            "x-language": language,
          }
        }).then((result) => {
          setCurrencyData(result.data.data);
        })
  }

  async function retrieveLoginSettings(token) {
    return () => axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/data`,
        {
          collection: 'SYS_LOGIN_SETTINGS',
          body: {},
        },
        {
          headers: {
            "x-token": token,
          }
        })
      .then(result => {
        const loginSettings = JSON.parse(JSON.parse(result.data.result)[0]?.settings || {})
        staticsSet(['loginSettings'], loginSettings)
        return;
      })
  }

  async function retrieveUsersList(token) {
    return axios.get(`${process.env.REACT_APP_API_BASE_URL}/data`, {
      headers: {
        'x-token': token,
        "x-collection": "CRM_USERS_LIST",
        "x-limit": 0,
        "x-filter": "",
        "x-sort": "[Name]",
        "x-language": language,
      }
    }).then((result) => {
      staticsSet(['usersList'], result.data.data)
    })
  }

  async function retrieveCustCatGroups(token) {
    return axios.get(`${process.env.REACT_APP_API_BASE_URL}/data`, {
      headers: {
        'x-token': token,
        "x-collection": "CRM_CUST_M_GROUPS",
        "x-limit": 0,
        "x-filter": "",
        "x-sort": "ShortName",
        "x-language": language,
      }
    }).then((result) => {
      staticsSet(['custCatGroups'], result.data.data)
    })
  }

  function getCustCatGroups() {
    return staticsGet(['custCatGroups'])
  }

  async function retrieveCustCats(token) {
    return axios.get(`${process.env.REACT_APP_API_BASE_URL}/data`, {
      headers: {
        'x-token': token,
        "x-collection": "CUST_M_CATEGORIES_BASE",
        "x-limit": 0,
        "x-filter": "",
        "x-sort": "Descr",
        "x-language": language,
      }
    }).then((result) => {
      staticsSet(['custCats'], result.data.data)
    })
  }

  function getCustCats() {
    return staticsGet(['custCats']);
  }

  function getUsersList() {
    return staticsGet(['usersList']) || [];
  }

  function getLoginDataFromLocalStorage() {
    const oldState = LocalStorage.loadState();

    if (!oldState?.token) {
      return null;
    }

    const oldLoginData = new LoginData(oldState.token);

    return (oldLoginData.getValidSeconds() < 120) ? null : oldLoginData;
  }
  /*
    useEffect(() => {
      if (!loginData) {
        if (!Object.keys(urlSearchParams_GET()).length) {
          const oldLoginData = getLoginDataFromLocalStorage();
          if (oldLoginData) {
            login(oldLoginData.get().token.token)
          }
        }
      }
    }, [loginData]);
  */
  /*
  Class methods
  */

  const login = (newToken) => {
    if (newToken === 'GUEST') {
      const newLoginData = new LoginData(newToken);
      setLoginData(newLoginData);
      return;
    }

    retrieveAllSettings(newToken,
      () => {
        setLoginData(new LoginData(newToken));
        LocalStorage.saveState({ token: newToken });
      }
    );
  };

  const logout = () => {
    setLoginData(undefined);
    statics_staticsReset();
    LocalStorage.saveState({ token: null });
  };

  const retrieveAllSettings = async (token, callback) => {
    Promise.all([
      retrieveLoginSettings(token),
      retrieveCurrencyData(token, language),
      retrieveUsersList(token),
      retrieveCustCats(token),
      retrieveCustCatGroups(token),
    ]).then(() => {
      if (callback) {
        callback(token)
      }
    }).catch(error => {
      console.error(error)
    })
  }

  const getLoginSettings = (keyArray) => {
    return staticsGet(['loginSettings', ...keyArray]);
  }

  const updateLoginSettings = async (keyArray, value, callback) => {
    if (!Array.isArray(keyArray) || !keyArray.length) {
      throw new Error("Deleting all loginSettings entry is not allowed.")
    }

    staticsSet(['loginSettings', ...keyArray], value);

    axios.put(`${process.env.REACT_APP_API_BASE_URL}/data`,
      {
        collection: 'SYS_LOGIN_SETTINGS',
        data: staticsGet(['loginSettings']),
      },
      {
        headers: {
          "x-token": loginData.getToken(),
        }
      }
    ).then(result => {
      if (callback) {
        callback(result)
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  const staticsGet = (keyArray) => {
    return statics_staticsGet(keyArray);
  };

  const staticsSet = (keyArray, value) => {
    statics_staticsSet(keyArray, value)
  }

  return (
    <MainContext.Provider
      value={{
        loginData,
        getLoginSettings,
        updateLoginSettings,
        login,
        logout,
        language,
        setLanguage,
        currencyData,
        setCurrencyData,
        staticsGet,
        staticsSet,
        getUsersList,
        getCustCatGroups,
        retrieveCustCatGroups,
        retrieveCustCats,
        getCustCats,
        searchParams,
        setSearchParams,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};

export default function useMain() {
  return useContext(MainContext);
}
